<!--
 * @Author: your name
 * @Date: 2021-12-03 09:26:57
 * @LastEditTime: 2021-12-28 15:20:50
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \new-website-1123\src\views\special\fx101\page9.vue
-->
<template>
  <div class="fx101-page9 pt80">
    <div class="text-div">
      <ctitle titleb="数据展示多样化"></ctitle>

      <p class="desc-p">
        平台为设备数据提供曲线图、对比图与表格等形式，历史数据可查看，且数据可导出与导入。
      </p>
    </div>

    <img
      class="data-img"
      src="https://stkjiot.com/resources/special/x101/8.jpg"
      alt="上太科技"
    />
  </div>
</template>

<script>
import ctitle from "@/components/sTitle/title1";
export default {
  name: "",
  components: {
    ctitle,
  },
  data() {
    return {};
  },
  created() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.fx101-page9 {
  position: relative;
  height: 100vh;
  text-align: center;
  justify-content: center;
  .text-div {
    position: relative;
    z-index: 2;
    .desc-p {
      font-size: 18px;
      font-weight: 400;
      color: rgba($color: #fff, $alpha: 0.6);
      line-height: 30px;
      margin-top: 59px;
      margin-bottom: 34px;
    }
  }
  .data-img {
    width: 1500px;
    height: 700px;
    object-fit: cover;
  }
}
@media screen and (max-width: $mobile-width) {
  .fx101-page9 {
    height: auto;
    .text-div {
      .desc-p {
        font-size: 0.27rem;
        line-height: 0.44rem;
        margin: auto;
        margin-top: 0.36rem;
        margin-bottom: 0.36rem;
        width: 86%;
      }
    }
    .data-img {
      width: 86%;
      height: unset;
      object-fit: contain;
    }
  }
}
</style>
